module.exports = __webpack_public_path__ + "static/media/Test23.b363bb5d.bmp";